import { Group, SegmentedControl, Select, Text } from '@byecode/ui'
import type { CustomViewLayout, DataSourceAbstract } from '@lighthouse/core'
import { CUSTOM_VIEW_LAYOUT, FIRST_DAY_OF_WEEK } from '@lighthouse/core'
import { FieldIconTypeMap, ListItem4ByecodeUi } from '@lighthouse/shared'
import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
    dataSource: DataSourceAbstract
    layout?: CustomViewLayout
}

const FIRST_DAY_OPTIONS = [
    {
        label: '今天',
        value: FIRST_DAY_OF_WEEK.TODAY
    },
    {
        label: '周一',
        value: FIRST_DAY_OF_WEEK.MONDAY
    },
    {
        label: '周日',
        value: FIRST_DAY_OF_WEEK.SUNDAY
    }
]

export const CalendarDateSelector = ({ dataSource, layout }: Props) => {
    const { control } = useFormContext()

    const dateOptions = useMemo(() => {
        return Object.values(dataSource.schema)
            .filter(item => item.innerType === 'DATE')
            .map(item => ({
                label: item.name,
                value: item.id,
                icon: FieldIconTypeMap[item.type]
            }))
    }, [dataSource.schema])

    if (layout === CUSTOM_VIEW_LAYOUT.monthCalendar) {
        return (
            <Group label="日历时间">
                <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                    <Text>开始日期 *</Text>
                    <Controller
                        name="calendarStartDateField"
                        control={control}
                        render={({ field }) => (
                            <Select
                                style={{ width: 180 }}
                                placeholder="请选择日期字段"
                                options={dateOptions}
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                            />
                        )}
                    />
                </ListItem4ByecodeUi>
                <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                    <Text>结束日期 *</Text>
                    <Controller
                        name="calendarEndDateField"
                        control={control}
                        render={({ field }) => (
                            <Select
                                style={{ width: 180 }}
                                placeholder="请选择日期字段"
                                options={dateOptions}
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                            />
                        )}
                    />
                </ListItem4ByecodeUi>
            </Group>
        )
    }

    return (
        <Group label="日历时间">
            <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                <Text>开始时间</Text>
                <Controller
                    name="calendarStartDateField"
                    control={control}
                    render={({ field }) => (
                        <Select
                            style={{ width: 180 }}
                            placeholder="请选择日期字段"
                            options={dateOptions}
                            value={field.value}
                            onChange={field.onChange}
                            searchable
                        />
                    )}
                />
            </ListItem4ByecodeUi>
            <ListItem4ByecodeUi alignItems="center" justifyContent="space-between">
                <Text>周起始于</Text>
                <Controller
                    name="firstDayOfWeek"
                    defaultValue={FIRST_DAY_OF_WEEK.TODAY}
                    control={control}
                    render={({ field }) => (
                        <SegmentedControl
                            style={{ width: 180 }}
                            fullWidth
                            data={FIRST_DAY_OPTIONS}
                            value={field.value}
                            onChange={field.onChange}
                        />
                    )}
                />
            </ListItem4ByecodeUi>
        </Group>
    )
}
